/*
  ErgoLab COD funnel: keeps the Worker's pending reservation in sync with what the
  customer has accepted so far. The product page reserves the base order at submit time
  (/reserve-cod-order); if the customer then accepts offer #1 but abandons on offer #2, the
  Worker's 15-minute auto-finalize would otherwise create the order WITHOUT offer #1. So
  every accepted offer re-posts the reservation with the full line list (same cartToken,
  same shape as the confirmation page's /submit-cod-order payload, see pdp-cod-pages.js).
  Best-effort and fire-and-forget (keepalive), never blocks navigation.
*/
(function () {
  'use strict';
  var PCO_SESSION_KEY = 'pco_session_v1';
  var DEFAULT_RESERVE_URL = 'https://ergolab-cod-worker.lukabozicth.workers.dev/reserve-cod-order';
  var FREE_MASK_VARIANT_ID = '42610235867241';

  function bases(session) {
    if (session && Array.isArray(session.bases) && session.bases.length) return session.bases.filter(function (b) { return b && b.variantId; });
    if (session && session.variantId) return [{ variantId: session.variantId, quantity: session.quantity || 1 }];
    return [];
  }
  function upsellLines(session) {
    var out = [];
    if (session && session.upsell && session.upsell.accepted && session.upsell.variantId) {
      var u = session.upsell;
      out.push({ role: 'upsell', variantId: u.variantId, qty: u.qty || 1 });
      (u.addons || []).forEach(function (a) { if (a && a.variantId) out.push({ role: 'upsellAddon', variantId: a.variantId, qty: a.qty || 1 }); });
    }
    ((session && session.extraUpsells) || []).forEach(function (x) {
      if (!x || !x.variantId) return;
      out.push({ role: x.role === 'upsellAddon' ? 'upsellAddon' : 'upsell', variantId: x.variantId, qty: x.qty || 1 });
    });
    return out;
  }

  window.pcoRefreshReservation = function (session) {
    try {
      if (!session) { try { session = JSON.parse(sessionStorage.getItem(PCO_SESSION_KEY) || 'null'); } catch (e) { session = null; } }
      if (!session || !session.token) return;
      var gift = session.gift || { variantId: FREE_MASK_VARIANT_ID, perUnit: 1 };
      var giftPerUnit = (gift.perUnit === 0 || gift.perUnit) ? Number(gift.perUnit) : 1;
      var lineItems = [];
      var units = 0;
      bases(session).forEach(function (b) { lineItems.push({ variantId: b.variantId, quantity: b.quantity || 1, role: 'base' }); units += (b.quantity || 1); });
      (session.addons || []).forEach(function (a) { if (a && a.variantId) lineItems.push({ variantId: a.variantId, quantity: a.qty || 1, role: 'addon' }); });
      var maskQty = units * giftPerUnit;
      upsellLines(session).forEach(function (l) {
        lineItems.push({ variantId: l.variantId, quantity: l.qty, upsell: true, role: l.role });
        if (l.role === 'upsell') maskQty += l.qty * giftPerUnit;
      });
      if (maskQty > 0) lineItems.push({ variantId: gift.variantId || FREE_MASK_VARIANT_ID, quantity: maskQty, role: 'gift' });
      if (!lineItems.length) return;
      var attrs = {};
      Object.keys(session.cartAttributes || {}).forEach(function (k) { attrs[k] = session.cartAttributes[k]; });
      var c = session.customer || {};
      attrs['Payment Method'] = session.paymentMethod || '';
      attrs['Full Name'] = c.fullName || '';
      attrs['Phone'] = c.phone || '';
      attrs['Email'] = c.email || '';
      attrs['Full Address'] = c.address || '';
      attrs['Zip Code'] = c.zip || '';
      fetch(session.reserveUrl || DEFAULT_RESERVE_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ cartToken: session.token, lineItems: lineItems, customer: c, cartAttributes: attrs })
      }).catch(function () { /* best-effort */ });
    } catch (e) { /* noop */ }
  };
})();
